import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "src/utils/localStorage";
import { getWorkspaceUuidFromCurrentUrl } from "src/utils/methods";

export const CREATOR_SEARCH_COLUMN_ORDER_KEY = "ws-creator-search-column-order";

export const CREATOR_SEARCH_COLUMN_OVERRIDES_KEY =
  "ws-creator-search-column-overrides-map";

type ColumnOverrides = Record<string, boolean>;

type SettingsByWorkspace<T> = Record<string, T>;

export const getColumnOverridesFromStorage = (): ColumnOverrides => {
  const activeWorkspaceUuid = getWorkspaceUuidFromCurrentUrl();
  if (!activeWorkspaceUuid) return {};

  const settingsByWorkspace = getFromLocalStorage<
    SettingsByWorkspace<ColumnOverrides>
  >(CREATOR_SEARCH_COLUMN_OVERRIDES_KEY);

  return settingsByWorkspace?.[activeWorkspaceUuid] ?? {};
};

export const saveColumnOverridesToStorage = (overrides: ColumnOverrides) => {
  const activeWorkspaceUuid = getWorkspaceUuidFromCurrentUrl();
  if (!activeWorkspaceUuid) return;

  const settingsByWorkspace =
    getFromLocalStorage<SettingsByWorkspace<ColumnOverrides>>(
      CREATOR_SEARCH_COLUMN_OVERRIDES_KEY,
    ) ?? {};

  saveToLocalStorage(CREATOR_SEARCH_COLUMN_OVERRIDES_KEY, {
    ...settingsByWorkspace,
    [activeWorkspaceUuid]: overrides,
  });
};

export const getColumnOrderFromStorage = (): string[] => {
  const activeWorkspaceUuid = getWorkspaceUuidFromCurrentUrl();
  if (!activeWorkspaceUuid) return [];

  const settingsByWorkspace = getFromLocalStorage<
    SettingsByWorkspace<string[]>
  >(CREATOR_SEARCH_COLUMN_ORDER_KEY);

  return settingsByWorkspace?.[activeWorkspaceUuid] ?? [];
};

export const saveColumnOrderToStorage = (columnOrder: string[]) => {
  const activeWorkspaceUuid = getWorkspaceUuidFromCurrentUrl();
  if (!activeWorkspaceUuid) return;

  const settingsByWorkspace =
    getFromLocalStorage<SettingsByWorkspace<string[]>>(
      CREATOR_SEARCH_COLUMN_ORDER_KEY,
    ) ?? {};

  saveToLocalStorage(CREATOR_SEARCH_COLUMN_ORDER_KEY, {
    ...settingsByWorkspace,
    [activeWorkspaceUuid]: columnOrder,
  });
};
